"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatOptions = formatOptions;
exports.getSubmitValue = getSubmitValue;
exports.isTaskNotification = isTaskNotification;
exports.toggle = exports.sectionHeader = exports.multiToggle = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _ui = require("@unite-us/ui");
function getSubmitValue(name, value, shouldIncludeEmail) {
  return shouldIncludeEmail ? (0, _defineProperty2.default)((0, _defineProperty2.default)({}, name, value), 'email', true) : (0, _defineProperty2.default)({}, name, value);
}
function formatOptions(opts) {
  return (0, _lodash.map)(opts, function (opt) {
    return {
      label: opt.display_name,
      value: opt.value
    };
  });
}
function isTaskNotification(notification) {
  return Object.prototype.hasOwnProperty.call(notification, 'task_new') || Object.prototype.hasOwnProperty.call(notification, 'task_due') || Object.prototype.hasOwnProperty.call(notification, 'task_overdue') || Object.prototype.hasOwnProperty.call(notification, 'task_assigned');
}
;
var sectionHeader = exports.sectionHeader = function sectionHeader(props, toggleValue, title, description, id, submitForm) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex py-4 pl-4 items-center",
    "data-test-element": id
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-1/2 sm:w-1/2 md:w-7/12 lg:w-4/6 xl:w-3/4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-lg font-extrabold font-medium-font py-2"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-sm font-extrabold font-medium-font"
  }, description)), props.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex w-1/2 sm:w-1/2 md:w-5/12 lg:w-2/6 xl:w-1/4"
  }, /*#__PURE__*/_react.default.createElement(_ui.UUToggleField, {
    id: "toggle-all-".concat(id, "-on"),
    value: toggleValue,
    onClick: function onClick() {
      return multiToggle(props, !toggleValue, submitForm);
    },
    label: "Turn ".concat(toggleValue ? 'off' : 'on', " all notifications"),
    valueText: toggleValue && "On"
  })));
};
var toggle = exports.toggle = function toggle(prop, submitForm) {
  return /*#__PURE__*/_react.default.createElement("div", {
    key: prop.name,
    className: "flex pl-4 space-x-12",
    "data-test-element": prop.name
  }, /*#__PURE__*/_react.default.createElement(_ui.UUToggleField, {
    value: prop.value,
    onClick: function onClick() {
      submitForm(getSubmitValue(prop.name, !prop.value, !prop.value));
    },
    label: prop.label,
    valueText: prop.value ? 'On' : 'Off',
    id: "toggle-".concat(prop.name),
    fullWidth: true
  }));
};
var multiToggle = exports.multiToggle = function multiToggle(props, toggleVal, submitForm) {
  var formData = {};
  var reminderFields = ['remind_sent_referrals', 'remind_received_referrals', 'remind_service_cases'];
  var reminderToggleVal = toggleVal ? 'on' : 'off';
  props.forEach(function (prop) {
    var value = reminderFields.indexOf(prop.name) > -1 ? reminderToggleVal : toggleVal;
    formData[prop.name] = value;
  });
  if (!isTaskNotification(formData)) {
    var excludeKeys = [].concat(reminderFields, ['email']);
    var anyNotificationsOn = (0, _lodash.some)(Object.values((0, _lodash.omit)(formData, excludeKeys))); // set email as true if any other setting is on (true)
    if (anyNotificationsOn) formData.email = true;
  }
  submitForm(formData);
};
//# sourceMappingURL=utils.js.map